import { Box, CircularProgress, Typography } from "@mui/material";
import StyledTitleDot from "../../components/common/StyledTitleDot";
import BreadCrumbs from "../../components/Breadcrumbs";
import AddBranchComponent from "../../components/Settings/AddBranch";
import { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";
import axios from "axios";
import { BranchesListProvider } from "../../contexts/BranchesList/BranchesList";
import { useTranslation } from "react-i18next";

export default function AddBranch() {
  const { t } = useTranslation();

  return (
    <>
      <BranchesListProvider>
        <Typography className="title" variant="h4">
          {t("addBranch")}
          <StyledTitleDot />
        </Typography>
        <BreadCrumbs routs={[t("addBranch")]} />

        <Box sx={{ marginTop: "2rem" }}>
          <AddBranchComponent />
        </Box>
      </BranchesListProvider>
    </>
  );
}
